import request from "@/utils/request/index";
export enum Api {
  KNOWLEDEGRAPH_PAGE = "/knowledgeGraph/page",
  KNOWLEDEGRAPH_IMPORT = "/knowledgeGraph/import",
  REMOVE = "/knowledgeGraph",
  DIGITALLIST = "/digitalMan",
  DIGITALDATA = "/digitalMan/getDigitalMans",
  DIGITALDELETE = "/digitalMan/digitalManDelete",
  DIGITALLISTSET = "/digitalMan/setting",
  MANSET = "/manSetting",
  MANSETPAGE = "/manSetting/page",
  KNOWLEDGEVASE = "/knowledgeBase",
  KNOWLEDGEVASEPAGE = "/knowledgeBase/page",
  KNOWLEDGEVASEADD = "/knowledgeBase/add",
  KNOWLEDGEVASEUPDATE = "/knowledgeBase/update",
  BINDITEM = "/digitalMan/bindItems",
}

// 知识图谱分页
export const knowledgeGraphList = (data?: any, config?: axiosConfig) =>
  request.get(Api.KNOWLEDEGRAPH_PAGE, data, config);

// 导入文件
export const importFile = (data?: any, config?: axiosConfig) =>
  request.post(Api.KNOWLEDEGRAPH_IMPORT, data, config);

// 删除
export const removeEvent = (data?: any, config?: axiosConfig) =>
  request.delete(Api.REMOVE + "/" + data, "", config);

// 数字人列表
export const digitalPage = (data?: any, config?: axiosConfig) =>
  request.get(Api.DIGITALLIST, data, config);

// 数字人删除
export const digitalDelete = (data?: any, config?: axiosConfig) =>
  request.delete(Api.DIGITALDELETE + "/" + data, config);


// 数字人分页列表
export const digitalData = (data?: any, config?: axiosConfig) =>
  request.get(Api.DIGITALDATA, data, config);

// 保存数字人
export const digitalSave = (data?: any, config?: axiosConfig) =>
  request.post(Api.DIGITALLISTSET, data, config);

// 数字人绑定展项
export const digitalBindItem = (data?: any, config?: axiosConfig) =>
  request.put(Api.BINDITEM, data, config);


// 人设列表
export const manSetList = (data?: any, config?: axiosConfig) =>
  request.get(Api.MANSET, data, config);

// 人设详情
export const manSetDetals = (data?: any, config?: axiosConfig) =>
  request.get(Api.MANSET + "/" + data, config);

// 人设删除
export const manSetDelete = (data?: any, config?: axiosConfig) =>
  request.delete(Api.MANSET + "/" + data, config);

// 人设分页列表
export const manSetPage = (data?: any, config?: axiosConfig) =>
  request.get(Api.MANSETPAGE, data, config);


// 人设保存
export const manSetSave = (data?: any, config?: axiosConfig) =>
  request.post(Api.MANSET, data, config);

// 知识库列表
export const knowledgeList = (data?: any, config?: axiosConfig) =>
  request.get(Api.KNOWLEDGEVASE, data, config);

// 知识库详情
export const knowledgeDetails = (data?: any, config?: axiosConfig) =>
  request.get(Api.KNOWLEDGEVASE + "/" + data, config);

// 知识库删除
export const knowledgeDelete = (data?: any, config?: axiosConfig) =>
  request.delete(Api.KNOWLEDGEVASE + "/" + data, config);

// 知识库分页列表
export const knowledgePage = (data?: any, config?: axiosConfig) =>
  request.get(Api.KNOWLEDGEVASEPAGE, data, config);

// 知识库保存
export const knowledgeAdd = (data?: any, config?: axiosConfig) =>
  request.post(Api.KNOWLEDGEVASEADD, data, config);

// 知识库编辑
export const knowledgeEdit = (data?: any, config?: axiosConfig) =>
  request.post(Api.KNOWLEDGEVASEUPDATE, data, config);






